var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 390",
    style: {
      enableBackground: "new 0 0 390 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.6,307c-20.1,10-42.2,15.3-64.9,15.3c-80.2,0-145.5-65.3-145.5-145.5S119.5,31.3,199.7,31.3c53.3,0,100,28.8,125.3,71.7 V0H25v30H0v30h25v70H0v30h25v70H0v30h25v70H0v30h25v30h300v-22.6L264.6,307z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6,245.6c13-19.8,20.5-43.4,20.5-68.8c0-69.3-56.2-125.5-125.5-125.5S74.2,107.4,74.2,176.7s56.2,125.5,125.5,125.5 c25.2,0,48.6-7.4,68.3-20.2l85.5,85.5l36.6-36.6L304.6,245.6z M277.6,241.8H121.1v-26.1h156.5V241.8z M277.6,189.7H121.1v-26.1 h156.5V189.7z M277.6,137.5H121.1v-26.1h156.5V137.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.a056cf63c3de6682b7ee0c7061b83eda.svg";
export { ForwardRef as ReactComponent };